module.exports = __webpack_public_path__ + "static/media/SYDummies25-2.48d9466c.png";